<template>
  <div class="login-container">
    <div class="earth-bg">
      <img src="../assets/png/bg-earth-1920.png" />
    </div>
    <div class="login-box">

      <div class="title-box">
        <!-- <img src="../assets/png/title.png" /> -->
        <!-- 九方NIO船舶调度指挥平台 -->
        山东海运股份有限公司
      </div>

      <div class="login-form">

        <div class="form-row">
          <img class="login-icon"
               src="../assets/png/login-user.png" />
          <input ref="user"
                 v-model="loginForm.user_name" />
        </div>

        <div class="form-row">
          <img class="login-icon"
               src="../assets/png/login-password.png" />
          <input ref="password"
                 type="password"
                 v-model="loginForm.password" />
        </div>

        <div class="form-row">
          <!-- <img class="loading" src="../assets/png/login-password.png" /> -->
          <button class="commit-button"
                  type="button"
                  @click="handleLogin()">{{loginName}}</button>
        </div>

        <!-- <div class="form-row" >
          <span class="tip" v-if="!loading" >登录中...</span>
        </div> -->
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { login } from "../api/modules/user";
import { setScreenToken, setUserName, setKey } from "@/utils/auth";

export default {
  name: "LoginPage",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入正确的用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请输入6位以上密码"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        user_name: "", //admin
        password: "", // admin1234
      },
      loginRules: {
        user_name: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      loginName: "登录",
      captchaSrc: "",
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
    isLoading: function (newV) {
      const loginDom = document.getElementsByClassName("commit-button")[0];
      if (newV) {
        loginDom.style.cursor = "none";
        this.loginName = "登录中...";
        // console.log(newV);
      } else {
        loginDom.style.cursor = "pointer";
        this.loginName = "登录";
      }
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  mounted() {
    // this.createUuid()
    if (this.loginForm.user_name === "") {
      this.$refs.user.focus();
    } else if (this.loginForm.password === "") {
      this.$refs.password.focus();
    }

    var inputText = this.$refs.password;
    inputText.addEventListener("keyup", (e) => {
      if (e.keyCode == 13) {
        this.handleLogin();
      }
    });
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    ...mapActions([
      "LOGIN",
      "SET_USERNAME",
      "SET_TOKEN",
      "SET_IS_LOADING",
      "SET_KEY",
    ]),
    checkCapslock(e) {
      const { key } = e;
      this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    onFocus(refName) {
      const dom = this.$refs[refName].$el;
      dom.style.border = "1px solid rgba(66, 179, 213, 0.6)";
      dom.style.boxShadow = "0px 0px 4px 2px rgba(66, 179, 213, 0.3)";
      // this.passwordType='password'
    },
    onBlur(refName) {
      this.capsTooltip = false;
      const dom = this.$refs[refName].$el;
      dom.style.border = "1px solid rgba(0, 0, 0, 0.15)";
      dom.style.boxShadow = "none";
    },
    handleLogin() {
      // console.log("111");
      this.SET_IS_LOADING(false);
      if (
        this.loginForm.user_name &&
        this.loginForm.password
        // &&
        // this.loginForm.password.length >= 6
      ) {
        this.LOGIN(this.loginForm).then(() => {
          this.$router.push("/map");
          this.SET_IS_LOADING(true);
        });
      } else {
        this.SET_IS_LOADING(false);
        return false;
      }
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
  },
};
</script>


<style lang="scss">
@import "../styles/variables.scss";
@media screen and (max-width: 1920px) {
  .login-container {
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: url("../assets/png/bg-login-1920.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .earth-bg {
      // height: 80%;
      width: 50%;
      position: absolute;
      left: 0;

      img {
        width: 80%;
        position: relative;
        right: -10%;
      }
    }

    .login-box {
      box-sizing: border-box;
      position: absolute;
      right: 0;
      width: 50%;

      .title-box {
        width: 50%;
        margin: 0 0 2vh 0;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 45px;
        text-shadow: 0px 2px 4px #55B4DC, 0px 1px 1px #00A5FF;

        img {
          width: 100%;
        }
      }

      .login-form {
        width: 50%;
        padding: 15px 0;
        overflow: hidden;
        background: rgba(34, 60, 98, 0.66);
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.11);
        border-radius: 4px;

        .form-row {
          .login-icon {
            height: 20px;
            position: relative;
            left: 5px;
            top: 5px;
          }

          input {
            box-sizing: border-box;
            height: 40px;
            margin: 15px 0 15px -20px;
            width: 70%;
            padding-left: 40px;
            font-size: 14px;
            color: $white;
            background: rgba(0, 26, 52, 0.42);
            border-radius: 2px;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }

          .loading {
            height: 20px;
            position: relative;
            left: 50px;
            top: 5px;
            animation: rotating 2s linear infinite;
          }

          button {
            box-sizing: border-box;
            height: 40px;
            width: 70%;
            color: $white;
            margin: 15px 0;
            background: #0090ca;
            border: none;
            border-radius: 2px;
            cursor: pointer;
          }

          .tip {
            box-sizing: border-box;
            /* height: 40px; */
            width: 70%;
            font-size: 12px;
            color: #c5bfbf;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1921px) {
  .login-container {
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: url("../assets/png/bg-login-1920.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .earth-bg {
      // height: 80%;
      width: 50%;
      position: absolute;
      left: 0;

      img {
        width: 80%;
        position: relative;
        right: -10%;
      }
    }

    .login-box {
      box-sizing: border-box;
      position: absolute;
      right: 0;
      width: 50%;

      .title-box {
        width: 50%;
        margin: 0 0 3vh 0;

        img {
          width: 100%;
        }
      }

      .login-form {
        width: 50%;
        padding: 30px 0;
        overflow: hidden;
        background: rgba(34, 60, 98, 0.66);
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.11);
        border-radius: 4px;

        .form-row {
          .login-icon {
            height: 30px;
            position: relative;
            left: 30px;
            top: 8px;
          }

          input {
            box-sizing: border-box;
            height: 60px;
            margin: 30px 0 30px -30px;
            width: 70%;
            padding-left: 60px;
            font-size: 24px;
            color: $white;
            background: rgba(0, 26, 52, 0.42);
            border-radius: 4px;
            border: 3px solid rgba(255, 255, 255, 0.1);
          }

          button {
            box-sizing: border-box;
            height: 60px;
            width: 70%;
            color: $white;
            margin: 30px 0;
            background: #0090ca;
            border: none;
            border-radius: 4px;
            font-size: 24px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 2561px) {
  .login-container {
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: url("../assets/png/bg-login-1920.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .earth-bg {
      // height: 80%;
      width: 50%;
      position: absolute;
      left: 0;

      img {
        width: 80%;
        position: relative;
        right: -10%;
      }
    }

    .login-box {
      box-sizing: border-box;
      position: absolute;
      right: 0;
      width: 50%;

      .title-box {
        width: 50%;
        margin: 0 0 3vh 0;

        img {
          width: 100%;
        }
      }

      .login-form {
        width: 50%;
        padding: 40px 0;
        overflow: hidden;
        background: rgba(34, 60, 98, 0.66);
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.11);
        border-radius: 4px;

        .form-row {
          .login-icon {
            height: 44px;
            position: relative;
            left: 30px;
            top: 6px;
          }

          input {
            box-sizing: border-box;
            height: 90px;
            margin: 40px 0 40px -40px;
            width: 70%;
            padding-left: 80px;
            font-size: 44px;
            color: $white;
            background: rgba(0, 26, 52, 0.42);
            border-radius: 8px;
            border: 6px solid rgba(255, 255, 255, 0.1);
          }

          button {
            box-sizing: border-box;
            height: 90px;
            width: 70%;
            color: $white;
            margin: 40px 0;
            background: #0090ca;
            border: none;
            border-radius: 8px;
            font-size: 44px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 6700px) {
  .login-container {
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: url("../assets/png/bg-login-1920.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

    .earth-bg {
      // height: 80%;
      width: 50%;
      position: absolute;
      left: 0;

      img {
        width: 80%;
        position: relative;
        right: -10%;
      }
    }

    .login-box {
      box-sizing: border-box;
      position: absolute;
      right: 0;
      width: 50%;

      .title-box {
        width: 50%;
        margin: 0 0 3vh 0;

        img {
          width: 100%;
        }
      }

      .login-form {
        width: 50%;
        padding: 60px 0;
        overflow: hidden;
        background: rgba(34, 60, 98, 0.66);
        box-shadow: 0px 8px 60px 0px rgba(0, 0, 0, 0.11);
        border-radius: 8px;

        .form-row {
          .login-icon {
            height: 66px;
            position: relative;
            left: 40px;
            top: 6px;
          }

          input {
            box-sizing: border-box;
            height: 120px;
            margin: 50px 0 50px -66px;
            width: 70%;
            padding-left: 120px;
            font-size: 66px;
            color: $white;
            background: rgba(0, 26, 52, 0.42);
            border-radius: 10px;
            border: 8px solid rgba(255, 255, 255, 0.1);
          }

          button {
            box-sizing: border-box;
            height: 120px;
            width: 70%;
            color: $white;
            margin: 60px 0;
            background: #0090ca;
            border: none;
            border-radius: 10px;
            font-size: 66px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
